const SecondmentIcon = ({ width = 14, height = 15, color = "#0971A2", className = "fill-[#0971A2]" }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <g clipPath="url(#clip0_7288_6348)">
            <path
                d="M7 0.378906C5.14319 0.378906 3.3631 1.11655 2.05041 2.42932C0.73767 3.74206 0 5.52208 0 7.37891C0 9.23573 0.737649 11.0158 2.05041 12.3285C3.36316 13.6412 5.14317 14.3789 7 14.3789C8.85683 14.3789 10.6369 13.6413 11.9496 12.3285C13.2623 11.0157 14 9.23573 14 7.37891C14 5.52208 13.2624 3.742 11.9496 2.42932C10.6368 1.11658 8.85683 0.378906 7 0.378906ZM6.98938 2.07805C7.43133 2.07805 7.82996 2.34435 7.99906 2.75282C8.16816 3.16128 8.07503 3.63179 7.76216 3.94467C7.44929 4.25672 6.97957 4.35066 6.57113 4.18156C6.16187 4.01247 5.89555 3.61383 5.89555 3.17107C5.89555 2.56738 6.3857 2.07805 6.98938 2.07805ZM9.25881 8.4957C9.25881 8.79876 9.0554 9.06262 8.78502 9.08142C8.63226 9.09285 8.48277 9.03077 8.38391 8.91395C8.28507 8.80204 8.23115 8.65826 8.23279 8.50877V12.3368C8.23279 12.666 7.96567 12.9332 7.63644 12.9332C7.30722 12.9332 7.0401 12.666 7.0401 12.3368V9.39275C7.0401 9.37968 7.0352 9.36742 7.02621 9.35844C7.01723 9.34945 7.00498 9.34373 6.99272 9.34373C6.96576 9.34373 6.94371 9.36579 6.94371 9.39275V12.3418V12.341C6.94371 12.671 6.6774 12.9374 6.34736 12.9374C6.01816 12.9374 5.75102 12.6711 5.75102 12.341V6.56874C5.53863 5.41447 4.50934 5.95932 3.90321 4.26835C3.73738 3.8207 3.63772 3.10672 3.64098 2.38704C3.64098 2.08316 3.84194 1.82175 4.14255 1.82175C4.41295 1.82175 4.62615 2.07827 4.64412 2.30291C4.72091 3.06344 4.81812 3.83703 5.19797 4.18912V4.1883C5.53372 4.50443 5.97648 4.68008 6.4372 4.67926H7.52449C8.47455 4.67926 9.24488 5.54109 9.24488 6.60305L9.25881 8.4957Z"
            />
        </g>
        <defs>
            <clipPath id="clip0_7288_6348">
                <rect
                    width={14}
                    height={14}
                    fill="white"
                    transform="translate(0 0.378906)"
                />
            </clipPath>
        </defs>
    </svg>
);
export default SecondmentIcon;
